import { render, staticRenderFns } from "./attr.vue?vue&type=template&id=115f1b20&scoped=true&"
import script from "./attr.vue?vue&type=script&lang=js&"
export * from "./attr.vue?vue&type=script&lang=js&"
import style0 from "./attr.vue?vue&type=style&index=0&id=115f1b20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115f1b20",
  null
  
)

export default component.exports